// extracted by mini-css-extract-plugin
export default {"advertSearchLink":"K8FxgfPE","advertSearchIcon":"_50EyOjZ+"};